import ApiService from '@/data/services/ApiService'

export class UserApiService extends ApiService {
  static async checkUnique(userId: number, data: object): Promise<object> {
    return this.axios.post('users/check-unique', {
      id: userId,
      ...data
    }).then(response => response.data)
  }

  static async resendInvitationEmail(userId: number): Promise<object> {
    return this.axios.get(`users/${userId}/resend-account-setup`).then(response => response.data)
  }

  static async getAllAbilities(): Promise<object> {
    return this.axios.get('abilities').then(response => response.data)
  }

  static async signup(data: object): Promise<object> {
    return this.axios.post('users/signup', data).then(response => response.data)
  }
}
